<template>
  <header class="header">
    <div class="container">
      <h1 class="logo">Adbc株式会社</h1>
      <nav class="global-nav">
        <ul>
          <li><a href="/3fb2950166ffcd90de8bcc56756543e8b5a9adc9#company">Adbc株式会社とは</a></li>
          <li><a href="/3fb2950166ffcd90de8bcc56756543e8b5a9adc9#recruit">採用情報</a></li>
          <li><a href="/3fb2950166ffcd90de8bcc56756543e8b5a9adc9#contact">お問い合わせ</a></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'LpHeader',
};
</script>

<style scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ヘッダー */
.header {
  background-color: #fff;
  padding: 1.5rem 0;
  border-bottom: 1px solid #eee;
  position: sticky; /* スクロールしても追従（任意） */
  top: 0;
  z-index: 100;
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  font-size: 2.4rem;
  font-weight: 700;
  color: #333;
}

.global-nav ul {
  display: flex;
  gap: 2.5rem;
}

.global-nav a {
  font-size: 1.6rem;
  color: #555;
  font-weight: 700;
  transition: color 0.3s ease;
}

.global-nav a:hover {
  color: #007bff;
  text-decoration: none;
}
</style>
